export const isValidEmailFormat = (email: string): boolean => {
  const regexEmail = new RegExp('^[A-Z0-9._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,}$', 'i');
  return regexEmail.test(email);
};
